import React from 'react'
import type { StepData } from '../../../services/onboardingService'

interface ShareholderBureauStepProps {
  onComplete?: (stepData: StepData) => Promise<void>
  stepData?: any
  stepKey?: string
}

const ShareholderBureauStep: React.FC<ShareholderBureauStepProps> = ({
  onComplete,
  stepData,
}) => {
  const handleComplete = async () => {
    if (onComplete) {
      await onComplete({
        completedAt: new Date().toISOString(),
        placeholder: true,
      })
    }
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Consulta Buró Accionista Mayoritario
        </h2>
        <p className="text-gray-600">Verificación crediticia del accionista</p>
      </div>

      {stepData?.status === 'completed' && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-green-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-green-800 font-medium">
              Consulta buró accionista completada
            </span>
          </div>
        </div>
      )}

      <div className="bg-white p-8 rounded-lg border border-gray-200">
        <div className="text-center">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Verificación Crediticia del Accionista
          </h3>
          <p className="text-gray-600 mb-6">
            Se realizará la consulta al buró de crédito del accionista
            mayoritario para complementar la evaluación financiera.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-700">
              <strong>Tiempo estimado:</strong> 10 minutos
            </p>
          </div>

          <button
            onClick={handleComplete}
            disabled={stepData?.status === 'completed'}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {stepData?.status === 'completed'
              ? 'Completado'
              : 'Simular Completar'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ShareholderBureauStep
